<div>
	@if (media?.mediaType === MediaType.Image) {
		<sim-image-viewer [media]="media" />
	}

	@if (media?.mediaType === MediaType.Video) {
		<sim-video-viewer
			[media]="media"
			[isPlaying]="displayedMedia?.isPlaying !== null ? displayedMedia?.isPlaying : false"
			[isLooping]="displayedMedia?.isLooping !== null ? displayedMedia?.isLooping : false"
			[initalPosition]="displayedMedia?.currentPosition !== null ? displayedMedia?.currentPosition : 0"
			[volume]="isValidVolume(displayedMedia?.volume) ? displayedMedia?.volume / 100 : 1"
		/>
	}

	@if (media?.mediaType === MediaType.Audio) {
		<sim-audio-viewer
			[media]="media"
			[isPlaying]="displayedMedia?.isPlaying !== null ? displayedMedia?.isPlaying : false"
			[isLooping]="displayedMedia?.isLooping !== null ? displayedMedia?.isLooping : false"
			[initalPosition]="displayedMedia?.currentPosition !== null ? displayedMedia?.currentPosition : 0"
			[volume]="isValidVolume(displayedMedia?.volume) ? displayedMedia?.volume / 100 : 1"
		/>
	}

	@if (media?.mediaType === MediaType.PDF) {
		<sim-document-viewer [media]="media" [pageNum]="displayedMedia?.currentPosition" />
	}

	@if (media?.mediaType === MediaType.PowerPoint) {
		<sim-presentation-viewer [media]="media" [pageNum]="displayedMedia?.currentPosition" [autoSize]="autoSize" />
	}
</div>
